import { render, staticRenderFns } from "./VariationCategory.vue?vue&type=template&id=238112ee&scoped=true"
import script from "./VariationCategory.vue?vue&type=script&lang=js"
export * from "./VariationCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238112ee",
  null
  
)

export default component.exports